import React from "react";
import { H4 } from "../../../../AbstractElements";
import { FormGroup, Label } from "reactstrap";

export default function ContactsPermissions({ register, handleAll }) {
  return (
    <>
      {" "}
      <H4 attrH4={{ className: "mb-0" }}>Contactos</H4>
      <FormGroup className="m-t-15 m-checkbox-inline m-0">
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            className="p-0 m-0"
            id="list_contact"
            type="checkbox"
            {...register("permissions.list_contact", {})}
          />
          <Label for="list_contact">
            {Option}
            <span className="digits"> Ver</span>
          </Label>
        </div>
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            className="p-0 m-0"
            id="create_contact"
            type="checkbox"
            {...register("permissions.create_contact", {})}
          />
          <Label for="create_contact">
            {Option}
            <span className="digits"> Crear</span>
          </Label>
        </div>
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            className="p-0 m-0"
            id="edit_contact"
            type="checkbox"
            {...register("permissions.edit_contact", {})}
          />
          <Label for="edit_contact">
            {Option}
            <span className="digits"> Modificar</span>
          </Label>
        </div>
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            className="p-0 m-0"
            id="delete_contact"
            type="checkbox"
            {...register("permissions.delete_contact", {})}
          />
          <Label for="delete_contact">
            {Option}
            <span className="digits"> Eliminar</span>
          </Label>
        </div>
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            className="p-0 m-0"
            id="export_contact"
            type="checkbox"
            {...register("permissions.export_contact", {})}
          />
          <Label for="export_contact">
            {Option}
            <span className="digits"> Exportar</span>
          </Label>
        </div>
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            onChange={handleAll}
            className="p-0 m-0"
            id="contact"
            type="checkbox"
          />
          <Label for="contact">
            {Option}
            <span className="digits"> Todos</span>
          </Label>
        </div>
      </FormGroup>
    </>
  );
}
